// extracted by mini-css-extract-plugin
export default {"container":"FileViewer_container__rqdtd","image":"FileViewer_image__mCFA7"};